<template>
  <div>
    <section-definition
      :title="page.title"
      :extraOptions="page.options"
      :icon="page.icon"
      :exportOptions="page.exportOptions"
      :breadcrumbs="page.breadcrumbs"
      @openFilter="openRecordingReportFilter"
      @refreshPage="refreshRecordingReportPage"
      @exportData="exportRecordingReport"
      :style="styleObject"
    ></section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table
        :headers="headers"
        :items="recording_date"
        class="elevation-1"
        :pagination.sync="pagination"
        :total-items="recordingtotal"
        :rows-per-page-items="[5, 10, 25]"
      >
        <template v-slot:items="props">
          <td class="checkEmpty p0">{{ props.item.calldate }}</td>
          <td class="checkEmpty p0">{{ props.item.uniqueid }}</td>
          <td class="checkEmpty p0">{{ props.item.phone_number }}</td>
          <td class="checkEmpty p0">{{ props.item.campaign }}</td>
          <td class="checkEmpty p0">{{ props.item.call_type }}</td>
          <td class="checkEmpty p0">{{ props.item.agent }}</td>
          <td class="checkEmpty p0">{{ props.item.agent_name  == null ? "N/A" : props.item.agent_name }}</td>
          <td class="checkEmpty p0">{{ props.item.team == null ? "N/A" :props.item.team  }}</td>
          <td class="checkEmpty p0">{{ props.item.station }}</td>
          <td class="checkEmpty p0">{{ props.item.duration }}</td>
          <td class="checkEmpty p0">{{ props.item.talk_times }}</td>
          <td class="text-xs-center checkEmpty">
            <div class="row">
              <v-btn
                small
                fab
                flat
                color="info"
                @click="togglePlayingRecordSheet('Listen', props.item)"
              >
                <i class="fas fa-microphone"></i>
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <!-- <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="1000">
          <pdfexport
            v-if="dialog"
            :header="pdf.header"
            :pdfdata="pdf_data"
            @closeModel="closeModel"
            title="Recording Report Details"
          ></pdfexport>
        </v-dialog>
      </v-layout>
    </div> -->
    <v-navigation-drawer
      fixed
      right
      :value="page.isFilterOpen"
      class="filterNavigation"
    >
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <v-container class="sidenavContainer">
        <RecordingReportFilter
          v-if="page.isFilterOpen"
          @getDataFrom="getDataFrom"
          :appliedfilter="appliedfilter"
        ></RecordingReportFilter>
      </v-container>
      <v-container row class="sidenavFooter">
        <v-btn flat @click="resetvalue()">Reset</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="getDataFromApi">Filter</v-btn>
      </v-container>
    </v-navigation-drawer>
    <v-bottom-sheet
      v-model="page.playingRecord"
      hide-overlay
      persistent
      lazy
      inset
      max-width="500"
      class="align-left"
      id="barging-div"
      transparent
    >
      <v-card tile class="player-div">
        <v-toolbar color="light" small>
          <audio controls autoplay v-if="page.playingRecord">
            <source :src="recordingplay" type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <v-spacer></v-spacer>
          <div class="row justify-fe">
            <a :href="recordingplay" target="_blank">
              <v-btn icon>
                <i class="fas fa-download"></i>
              </v-btn>
            </a>
            <v-btn icon>
              <v-icon @click="togglePlayingRecordSheet('close', {})"
                >close</v-icon
              >
            </v-btn>
          </div>
        </v-toolbar>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
import RecordingReportFilter from "./Components/RecordingReportFilter";
// import pdfexport from "./Components/pdfexport";
import { mapGetters } from "vuex";
import jwtDecode from "jwt-decode";
import moment from "moment";
export default {
  components: {
    loader,
    RecordingReportFilter,
    // pdfexport,
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    // this.$store.dispatch("reportuserlist").then(() => {
    //   // this.getDataFromApi();
    //   this.dateformate();
    // });
    this.dateformate();
    var apiInfo = JSON.parse(localStorage.apiInfo); 
    this.token = apiInfo.token;
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "reports:recording:export"
          ) !== -1
        ) {
          scope.page.exportOptions = ["CSV", "Txt(Tab-Delimited)"];
        } else {
          scope.page.exportOptions = [];
        }
      }.bind(scope),
      1
    );
  },
  computed: {
    ...mapGetters(["recording_date", "auth0accessToken"]),
  },
  data() {
    return {
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Call Recordings Report",
        icon: "fa-compact-disc",
        loading: true,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        exportOptions: [],
        options: { filter: true, refresh: true },
      },
      payload: {
        form_date: "",
        to_date: "",
        skip: 0,
        take: 0,
        agent: "",
        descending: "",
        export: "exportrecordigdetails",
      },
      token: "",
      appliedfilter: {
        phonenumber: "",
        type: "",
        station: "",
        agent: "",
        did: "",
        queue: "",
        dispo: "",
        status: "",
        flag: false,
        f_flag: 0,
        t_flag: 0,
      },

      url: "",
      dialog: false,
      recordingplay: "",
      pagination: {
        rowsPerPage: 10,
      },
      local_token: "",
      headers: [
        {
          text: "Date Time",
          align: "left",
          sortable: true,
          class: "p0",
          value: "calldate",
        },
        {
          text: "Uniqueid",
          align: "left",
          sortable: true,
          class: "p0",
          value: "uniqueid",
        },
        {
          text: "Phone Number",
          align: "left",
          sortable: true,
          class: "p0",
          value: "phone",
        },
        {
          text: "Campaign",
          align: "left",
          sortable: true,
          class: "p0",
          value: "campaign",
        },
        {
          text: "Call Type",
          align: "left",
          sortable: false,
          class: "p0",
          value: "call_type",
        },
        {
          text: "Agent",
          align: "left",
          sortable: true,
          class: "p0",
          value: "agent",
        },
        { text: "Agent Name",
          align: "left", 
          sortable: true, 
          value: "agentname",
          class: "p0",
        },
        { text: "Team",
          align: "left", 
          sortable: true, 
          value: "team",
          class: "p0",
        },

        {
          text: "Station",
          align: "left",
          sortable: true,
          class: "p0",
          value: "station",
        },
        {
          text: "Duration",
          align: "left",
          sortable: true,
          class: "p0",
          value: "duration",
        },
        {
          text: "Talk Time",
          align: "left",
          sortable: true,
          class: "p0",
          value: "talk_times",
        },
        { text: "Play", align: "left", sortable: true, class: "p0", value: "" },
      ],
      header: [
        {
          text: "Date Time",
          align: "left",
          sortable: true,
          value: "calldate",
        },
        {
          text: "Uniqueid",
          align: "left",
          sortable: true,
          value: "uniqueid",
        },
        {
          text: "Phone Number",
          align: "left",
          sortable: true,
          value: "phone",
        },
        {
          text: "Call Type",
          align: "left",
          sortable: false,
          value: "call_type",
        },
        { text: "Agent", align: "left", sortable: true, value: "agent" },
        { text: "Station", align: "left", sortable: true, value: "station" },
        { text: "Duration", align: "left", sortable: true, value: "duration" },
        { text: "Play", align: "left", sortable: true, value: "" },
      ],
      // pdf: {
      //   header: [
      //     {
      //       text: "Date Time",
      //       align: "left",
      //       sortable: true,
      //       value: "calldate",
      //     },
      //     {
      //       text: "Uniqueid",
      //       align: "left",
      //       sortable: true,
      //       value: "uniqueid",
      //     },
      //     {
      //       text: "Phone Number",
      //       align: "left",
      //       sortable: true,
      //       value: "phone",
      //     },
      //     {
      //       text: "Call Type",
      //       align: "left",
      //       sortable: false,
      //       value: "call_type",
      //     },
      //     { text: "Agent", align: "left", sortable: true, value: "agent" },
      //     { text: "Station", align: "left", sortable: true, value: "station" },
      //     {
      //       text: "Duration",
      //       align: "left",
      //       sortable: true,
      //       value: "duration",
      //     },
      //     {
      //       text: "Talk Time",
      //       align: "left",
      //       sortable: true,
      //       value: "talk_times",
      //     },
      //     {
      //       text: "Recording Path",
      //       align: "left",
      //       sortable: true,
      //       value: "record_path",
      //     },
      //   ],
      //   item: [],
      // },
      recordingreport: [],
      recordingtotal: 0,
      txt_data: [],
      // pdf_data: [],
      excel_data: [],
      page_flag: false,
      pages: "",
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  methods: {
    closeModel: function () {
      this.dialog = false;
    },
    openRecordingReportFilter: function () {
      this.page.isFilterOpen = true;
    },
    refreshRecordingReportPage: function () {
      var scope = this;
      scope.getDataFromApi();
      scope.dateformate();
      scope.page.loading = true;
      this.refreshvalue();
      this.appliedfilter.phonenumber = "";
      this.appliedfilter.type = "";
      this.appliedfilter.station = "";
      this.appliedfilter.agent = "";
      this.appliedfilter.did = "";
      this.appliedfilter.queue = "";
      this.appliedfilter.dispo = "";
      this.appliedfilter.status = "";
      this.appliedfilter.uniqueid = "";
    },
    exportRecordingReport: function (option) {
      if (option == "CSV" || option == "Txt(Tab-Delimited)") {
        this.export(option);
      } else {
        this.dialog = true;
        this.export(option);
        // this.pdf_flag = true;
      }
    },
    togglePlayingRecordSheet: function (event, item) {
      if (event == "close") {
        this.page.playingRecord = false;
      } else {
        var date = moment(item.calldate).format("YYYY-MM-DD");
        var decoded = jwtDecode(this.token);
        var tid = decoded["http://api.doocti.com/claims/tenant_code"];
        var items = {
          id: item.uniqueid,
          date: date,
          tid: tid,
        };
        return new Promise(() => {
          this.$store.dispatch("audioplay", items).then((response) => {
            this.recordingplay = response.url;
            if (this.recordingplay != "") {
              this.page.playingRecord = true;
            }
          });
        });
      }
    },
    dateformate() {
      this.page.loading = false;
      this.to_date = new Date();
      this.to_date = moment(this.to_date).format("YYYY-MM-DD HH:mm:ss");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.from_date = moment(from_date1).format("YYYY-MM-DD HH:mm:ss");
      this.$store.commit("FILTERFROMDATE", this.from_date);
      this.$store.commit("FILTER_TODATE", this.to_date);
      // this.getDataFrom();
    },
    getDataFromApi() {
      var scope = this;
      var to_date = new Date();
      this.payload.to_date = moment(to_date).format("YYYY-MM-DD HH:mm:ss");
      var from_date1 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date1.setTime(from_date1.getTime() - dateOffset);
      this.payload.from_date = moment(from_date1).format("YYYY-MM-DD HH:mm:ss");
      var { page, rowsPerPage } = this.pagination;
      this.payload.take = rowsPerPage;
      //scope.$store
      //  .dispatch("reportuserlist")
      //  .then((response) => {
      let dataa = JSON.parse(localStorage.getItem("group_users"));
      scope.payload.agent = dataa;
      if (rowsPerPage == undefined) {
        rowsPerPage = 5;
      }
      if (rowsPerPage == -1) {
        this.payload.take = this.total;
      } else {
        this.payload.take = rowsPerPage;
      }
      if (page != "" && page != undefined && page != null) {
        this.skip = page;
      } else {
        this.skip = 1;
      }
      this.payload.skip = (this.skip - 1) * this.payload.take;
      return new Promise((resolve) => {
        var { descending } = scope.pagination;
        this.payload.descending = descending;
        this.$store
          .dispatch("recordingdetails", this.payload)
          .then((response) => {
            scope.page.loading = false;
            if (scope.page_flag) {
              this.pagination.page = 1;
              scope.page_flag = false;
            }
            this.total = response.count;
            this.recordingtotal = this.total;
            resolve(this.total);
            if (response.response.status === 401) {
              scope.$store.dispatch("checkingtoken");
            }
          })
          .catch(function (err) {
            if (err.response.status === 401) {
              scope.$store.dispatch("checkingtoken");
            }
          });
      });
      //})
      // .catch(() => {

      // });
    },
    getDataFrom() {
      this.skip = 0;
      this.getDataFromApi();
      this.page_flag = true;
    },

    resetvalue() {
      var to_date = new Date();
      to_date = moment(to_date).format();
      var from_date = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 30;
      from_date.setTime(from_date.getTime() - dateOffset);
      from_date = moment(from_date).format();
      this.refreshvalue();
      this.$store.dispatch("fromdate", from_date);
      this.$store.dispatch("todate", to_date);
      this.appliedfilter.uniqueid = "";
      this.appliedfilter.phonenumber = "";
      this.appliedfilter.type = "";
      this.appliedfilter.station = "";
      this.appliedfilter.agent = "";
      this.appliedfilter.did = "";
      this.appliedfilter.queue = "";
      this.appliedfilter.dispo = "";
      this.appliedfilter.status = "";
      this.appliedfilter.flag = true;
      this.appliedfilter.fromdate = "";
      this.appliedfilter.todate = "";
      if (this.appliedfilter.flag) {
        this.appliedfilter.fromdate = from_date;
        this.appliedfilter.todate = to_date;
        this.appliedfilter.flag = false;
      }
    },
    export(option) {
      this.excel_data = [];
      this.txt_data = [];
      // this.pdf_data = [];
      var export_date = {
        from_date: this.payload.from_date,
        to_date: this.payload.to_date,
        calldetail: "exportrecordigdetails",
      };
      this.$store.dispatch("exportdatafetch", export_date).then((response) => {
        this.exports = response;
        var phone;
        for (var i = 0; i < this.exports.length; i++) {
          if (response[i].phone_number) {
            var mobile_number = response[i].phone_number;
            var reg = new RegExp("[&/\\#,+()$~%.'\":*?<>{}]", "gi");
            var phone_number = mobile_number.replace(reg, "");
            phone = phone_number.replace(" ", "");
          }
          if (response[i].calldate) {
            var date = new Date(response[i].calldate);
            var options = {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            };
            var timeString = date.toLocaleString("en-US", options);
            this.call_date = response[i].calldate.substr(0, 11) + timeString;
          }
          this.excel_data.push({
            Date: this.call_date,
            uniqueid: response[i].uniqueid,
            Phone: phone,
            Campaign: response[i].campaign,
            Call_Type: response[i].call_type,
            Agent: response[i].agent,
            agentName:response[i].agent_name,
            team:response[i].team,
            Station: response[i].station,
            Duration: response[i].duration,
            Talk_Time: response[i].talk_times,
            Recording_Path: response[i].record_location,
          });
          this.txt_data.push([
            this.call_date,
            response[i].uniqueid,
            phone,
            response[i].campaign,
            response[i].call_type,
            response[i].agent,
            response[i].agent_name,
            response[i].team,
            response[i].station,
            response[i].duration,
            response[i].talk_times,
            response[i].record_location,
          ]);
          // this.pdf_data.push([
          //   this.call_date,
          //   response[i].uniqueid,
          //   phone,
          //   response[i].campaign,
          //   response[i].call_type,
          //   response[i].agent,
          //   response[i].station,
          //   response[i].duration,
          //   response[i].talk_times,
          //   response[i].record_location,
          // ]);
        }

        if (option == "Txt(Tab-Delimited)") {
          let txtContent = "";
          let txt_key = [
            "Date Time",
            "Uniqueid",
            "Phone Number",
            "Campaign",
            "Call Type",
            "Agent","Agent Name","Team",
            "Station",
            "Duration",
            "Talk Time",
            "Recording_Path",
          ];

          let txt_tab = txt_key.join("\t");
          txtContent += `${txt_tab} \r\n`;
          //  csvContent += "Date,Uniqueid,DID,Queue,Phone Number,Call type ,Queue Enter Time ,Answer Time ,Application ,Agent ,Station,Dispo Status,Status ,Duration ,Talk Time,Comments \r\n";
          this.txt_data.forEach(function (rows) {
            let data = Object.values(rows);
            let row = data.join("\t");
            txtContent += row + "\r\n";
          });
          var date1 = new Date();
          date1 = moment(date1).format("YYYY-MM-DD hh-mm");
          var encodedUri1 =
            "data:text/plain;charset=utf-8,\uFEFF" +
            encodeURIComponent(txtContent);
          var link1 = document.createElement("a");
          link1.setAttribute("href", encodedUri1);
          link1.setAttribute("download", "recorddetails" + date1 + ".txt");
          document.body.appendChild(link1);
          link1.click();
        }
        if (option == "CSV") {
          //var BOM = "\uFEFF";
          let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
          csvContent +=
            "Date Time,Uniqueid,Phone Number,Campaign,Call Type,Agent,Agent Name,Team,Station,Duration,Talk Time,Recording_Path\r\n";
          this.excel_data.forEach(function (rows) {
            var data = Object.values(rows);
            let data1 = [];
            data.forEach((elm) => {
              if (typeof elm === "string") {
                data1.push(elm.replace(/'|"|#|\n/g, " "));
              } else {
                data1.push(elm);
              }
            });
            let row = data1.join(",");
            csvContent += row + "\r\n";
          });
          var d = new Date();
          d = moment(d).format("YYYY-MM-DD hh-mm");
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "RecordingReport_" + d + ".csv");
          document.body.appendChild(link);
          link.click();
        }
      });
    },

    refreshvalue() {
      this.$store.commit("FILTER_AGENT", { agent: "" });
      this.$store.commit("FILTER_TYPE", { type: "" });
      this.$store.commit("FILTER_STATION", { station: "" });
      this.$store.commit("FILTER_QUEUE", { queue: "" });
      this.$store.commit("FILTER_PHONE", { phone: "" });
      this.$store.commit("FILTER_CAMPAIGN", { campaign: "" });
      this.$store.commit("FILTER_UNIQUEID", { uniqueid: "" });
    },
  },

  beforeDestroy() {
    this.$store.commit("FILTER_AGENT", { agent: "" });
    this.$store.commit("FILTER_TYPE", { type: "" });
    this.$store.commit("FILTER_STATION", { station: "" });
    this.$store.commit("FILTER_QUEUE", { queue: "" });
    this.$store.commit("FILTER_PHONE", { phone: "" });
    this.$store.commit("FILTER_CAMPAIGN", { campaign: "" });
    this.$store.commit("FILTER_UNIQUEID", { uniqueid: "" });
  },
};
</script>
<style>
.icons {
  height: 80px;
}
</style>
